import * as accountActions from "./account/actions.js";
import * as customerActions from "./customer/actions.js";
import * as sellInquiryFormActions from "./sellInquiryForm/actions.js";
import * as contractActions from "./contract/actions.js";
export default {
	...accountActions,
	...customerActions,
	...sellInquiryFormActions,
	...contractActions,
};
